import { notification, Spin } from 'antd';
import extractUrlValue from '../../utils/extractUrlValue';
import { useEffect, useMemo } from 'react';
import { useLazyGetAllFromKosQuery } from '../../store/commonApiKos';
import { useNavigate } from 'react-router-dom';
import buildQueryString from '../../utils/buildQueryString';

function SSORedirect() {
    const navigate = useNavigate();
    const [trigger] = useLazyGetAllFromKosQuery();
    const [getRoleTrigger] = useLazyGetAllFromKosQuery();
    const [setRoleTrigger] = useLazyGetAllFromKosQuery();
    const completeUrlString = useMemo(() => {
        return (
            ExtractFromUrl() +
            '&' +
            buildQueryString({
                redirect_url:
                    window.location.origin + '/SSORedirect?name=' + extractUrlValue('name'),
            })
        );
    }, []);

    useEffect(() => {
        trigger({
            endpoint: 'sso_callback' + completeUrlString,
            urlBase: '/connector/',
        })
            .then(async (response) => {
                if (response.error) {
                    navigate('/');
                } else {
                    localStorage.setItem('data', JSON.stringify(response.data?.data));
                    // GET role info (no app_user_id needed)
                    const roleResponse = await getRoleTrigger({
                        endpoint: 'get_role',
                        method: 'GET',
                        urlBase: '/user_role/',
                    }).unwrap();
                    const firstRole = roleResponse?.roles?.[0];
                    if (!firstRole) {
                        // Debug: log full response if no roles found
                        console.error('Role response missing roles:', roleResponse);
                        navigate('/');
                        notification.error({
                            message: 'No roles assigned to this user. Please contact support.',
                        });
                        return;
                    }
                    const role_id = firstRole.role_id;
                    const user_group_id = firstRole.user_group_id;
                    // POST to set role
                    await setRoleTrigger({
                        endpoint: 'set_role', // changed from 'get_role' to 'set_role'
                        body: { role_id, user_group_id },
                        method: 'POST',
                        urlBase: '/user_role/',
                    }).unwrap();
                    navigate('/ProgramPage/');
                }
            })
            .catch((error) => console.error(error));
    }, [completeUrlString, navigate, trigger]);

    return <Spin size='large' />;
}

function ExtractFromUrl() {
    const url = new URL(window.location.href);
    return url.search;
}

export default SSORedirect;
